"use client";

import {
  Check,
  ChevronsUpDown,
  CircleGauge,
  Megaphone,
  FileLineChart,
  Settings,
  BadgeHelp,
  BadgeCheck,
  TrendingUp,
  DollarSign,
  Headset,
  ShoppingCart,
  PencilIcon,
  PlusIcon,
  Trash,
  ChevronRight,
  DollarSignIcon,
  ChevronDown,
  ArrowUp,
  ArrowDown,
  Clock,
  Phone,
  MessageSquareMoreIcon,
  MessageSquareReply,
  Mail,
  EllipsisVertical,
  Ellipsis,
  Users,
  RotateCcw,
  Info,
} from "lucide-react";
import Link from "next/link";

import {
  google,
  logo,
  logoText,
  inbox,
  whiteCheck,
  playGreen,
  shopify,
  pauseGreen,
} from "../assets/icons";

export const ICON_MAP = {
  "badge-check": BadgeCheck,
  "badge-help": BadgeHelp,
  check: Check,
  "chevrons-up-down": ChevronsUpDown,
  "chevron-down": ChevronDown,
  "chevron-right": ChevronRight,
  "circle-gauge": CircleGauge,
  "dollar-sign": DollarSign,
  "file-line-chart": FileLineChart,
  google: google,
  headset: Headset,
  megaphone: Megaphone,
  settings: Settings,
  "shopping-cart": ShoppingCart,
  "trending-up": TrendingUp,
  pencil: PencilIcon,
  plus: PlusIcon,
  trash: Trash,
  dollar: DollarSignIcon,
  clock: Clock,
  "arrow-up": ArrowUp,
  "arrow-down": ArrowDown,
  inbox: inbox,
  message: MessageSquareMoreIcon,
  messageReply: MessageSquareReply,
  phone: Phone,
  mail: Mail,
  logo: logo,
  "logo-text": logoText,
  "ellipsis-vertical": EllipsisVertical,
  ellipsis: Ellipsis,
  team: Users,
  "white-check": whiteCheck,
  shopify: shopify,
  "play-green": playGreen,
  "pause-green": pauseGreen,
  rotate: RotateCcw,
  info: Info,
};

export type IIconName = keyof typeof ICON_MAP;

interface IIconProps extends React.SVGProps<SVGSVGElement> {
  name: IIconName;
  href?: string;
  className?: string;
}

const Icon: React.FC<IIconProps> = ({
  name,
  href,
  className = "",
  ...props
}) => {
  const IconComponent = ICON_MAP[name];

  if (!!href) {
    return (
      <Link href={href}>
        <IconComponent className={className} {...props} />
      </Link>
    );
  }

  return <IconComponent className={className} {...props} />;
};

export { Icon };
